document.addEventListener('DOMContentLoaded', function () {
    var variantSelectors = document.querySelectorAll('.single-option-selector');
    variantSelectors.forEach(function(selector) {
        selector.addEventListener('change', function(event) {
            // Prevent URL from changing when variant is selected
            event.preventDefault();  // Stop the default action

            // Update the product information without changing the URL
            var form = this.closest('form');  // Find the form
            var variantId = form.querySelector('select[name="id"]').value;  // Get selected variant ID

            // Optionally, you can update some variant-related information here
            console.log('Selected variant ID:', variantId); // Log for debugging

            // Update the page without changing the URL
            window.history.replaceState({}, document.title, window.location.pathname);
        });
    });
});

